import React from 'react';

import { Autocomplete, Box, Button, Stack, TextField } from '@mui/material';

export function ReportFilters({
  definitions,
  values,
  options,
  onChange,
}: {
  definitions: ReadonlyArray<readonly [string, string]>;
  values: Record<string, Array<string>>;
  options: Record<string, Array<string>>;
  onChange: (key: string, values: Array<string>) => void;
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,minmax(0,1fr))', lg: 'repeat(4,minmax(0,1fr))' },
        gap: 1.5,
      }}
    >
      {definitions.map(([key, label]) => (
        <Stack key={key}>
          <Autocomplete
            multiple
            size="small"
            options={options[key] ?? []}
            value={values[key] ?? []}
            onChange={(_, v) => onChange(key, v)}
            renderInput={(p) => (
              <TextField {...p} label={label} placeholder={(values[key] ?? []).length ? '' : 'All'} />
            )}
          />
          <Stack direction="row">
            <Button size="small" onClick={() => onChange(key, [])}>
              All
            </Button>
            <Button size="small" onClick={() => onChange(key, ['__NONE__'])}>
              None
            </Button>
          </Stack>
        </Stack>
      ))}
    </Box>
  );
}
